import { useEffect, useRef, useState } from "react";
import { Mic, Square } from "lucide-react";
import { toast } from "sonner";

export default function VoiceButton({ onTranscript, testid }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);
  const supported = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

  useEffect(() => () => { try { recRef.current?.stop(); } catch { /* noop */ } }, []);

  if (!supported) return null;

  const toggle = () => {
    if (listening) {
      recRef.current?.stop();
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.lang = "en-GB";
    rec.interimResults = false;
    rec.continuous = true;
    rec.onresult = (e) => {
      let text = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) text += e.results[i][0].transcript;
      }
      if (text.trim()) onTranscript(text.trim());
    };
    rec.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed") toast.error("Microphone access denied — allow the mic in your browser");
    };
    rec.onend = () => setListening(false);
    recRef.current = rec;
    try {
      rec.start();
      setListening(true);
    } catch {
      toast.error("Couldn't start the microphone");
    }
  };

  return (
    <button type="button" onClick={toggle} data-testid={testid}
      title={listening ? "Stop — tap when finished speaking" : "Speak to fill this in"}
      className={`h-7 w-7 rounded-full grid place-items-center transition-colors shrink-0 ${
        listening ? "bg-[#D5281B] text-white animate-pulse" : "bg-slate-100 text-slate-500 hover:bg-sky-100 hover:text-[#005EB8]"}`}>
      {listening ? <Square className="h-3 w-3" /> : <Mic className="h-3.5 w-3.5" />}
    </button>
  );
}
